<!--库存统计-->
<template>
	<div class="content">
        <h3>库存统计</h3>
		<div class="item">
            <el-form ref="form" style="width:100%" inline :model="form" label-width="80px">
                <el-form-item label="产品">
					<el-input v-model="form.product" placeholder="请选择" :value="form.productnum" @focus="productfocus"></el-input>					
				</el-form-item>
                <el-form-item label="统计库房">
					<el-select v-model="form.outstore" @change="selChange" placeholder="请选择" >
						<el-option
						v-for="item in warehouse"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item> 
			</el-form>
			<div class="btn">
				<el-button type="primary" @click="selectQry">统 计</el-button>
                <el-button type="warning">重 置</el-button>
			</div>
		</div>
		<el-dialog
			title="选择产品"
			:visible.sync="dialogVisible"
			width="600px">
			<el-table :data="gridData" highlight-current-row
    @row-click="handleCurrentChange">
				<el-table-column align="center" width="80" property="id" label="序号"></el-table-column>
				<el-table-column align="center" width="80" property="num" label="产品编号"></el-table-column>
				<el-table-column align="center" width="200" property="name" label="产品名称"></el-table-column>
				<el-table-column align="center" width="80" property="pr" label="产品品柜"></el-table-column>
				<el-table-column align="center" width="80" property="scale" label="包装比例"></el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确 定</el-button>
			</span>
		</el-dialog>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column prop="FactoryName" label="顺序码起始值"></el-table-column>
				<el-table-column prop="FactoryCode" label="顺序码终止值"></el-table-column>
				<el-table-column prop="Address" label="产品编号"></el-table-column>
        		<el-table-column prop="Address" label="产品名称"></el-table-column>
        		<el-table-column prop="Address" label="产地"></el-table-column>
				<el-table-column prop="Address" label="班次"></el-table-column>
        		<el-table-column prop="Address" label="批次"></el-table-column>
        		<el-table-column prop="Address" label="生产日期"></el-table-column>
        		<el-table-column prop="Address" label="操作员"></el-table-column>
				<el-table-column prop="Address" label="创建时间"></el-table-column>
			</el-table>
      		<el-pagination
			background
			@current-change="handleCurrentChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
    	</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			dialogVisible: false,
			form: {
				timestate: 1, //时间类型
				starttime:'',  //起始时间
				endtime: '',   //结束时间
				odd: '',       //出库单号
				product: '',   //产品名称
				productnum:'', //产品编号
				outstore:'',   //出库库房
				outstate:'',   //出库类型
				num:'',        //数码
				checked1: false,  //单据类型选择
				checked2: false,  //单据类型选择
				
			},
			pageNum:0,
			options: [{
				value: 1,
				label: '创建时间'
				}, {
				value: 2,
				label: '更新时间'
			}],
            warehouse: [{
				value: '仓库1',
				label: '芬腾仓库'
			}],
            outstock: [{
				value: '出库1',
				label: '销售出库'
			},{
				value: '出库2',
				label: '调拨出库'
			}],
            

			gridData: [{
				id: '1',
				num: '130022',
				name: '婴童牛仔系列产品',
				pr: '1',
				scale: '1*1(盒)'
        	},{
				id: '2',
				num: '130021',
				name: '婴童POLO衫系列产品',
				pr: '1',
				scale: '1*1(盒)'
        	}],
			current:null,
			tableData: []
		}
	},
	methods:{
		selChange(val){
			
			
		},
		confirm(){
			this.form.product = this.current.pr + this.current.name +this.current.scale;
			this.form.productnum = this.current.num;
			this.dialogVisible = false
		},
		handleCurrentChange(data){
			this.current = data
		},


		productfocus(){
			//	请求产品数据
			this.$axios({
				method: 'post',
				url:'/getproductfocus',
				params:{
					
				}
			})
			.then(res=>{
				console.log(res);
				gridData=res;
			})
			this.dialogVisible = true
		},

		selectQry(){
			console.log(this.form)
			this.$axios({
				method: 'post',
				url:'/FW/OutListQry.ashx',
				params:{
					qry: this.form
				}
			})
			.then(res=>{
				console.log(res)
			})
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 80px;
}
.el-form--inline .el-form-item{
    width:300px;
    margin-bottom: 10px;
}
.el-input,.el-select {
	width:200px;
}
.el-checkbox{
    line-height: 19px;
}
</style>


// WEBPACK FOOTER //
// src/pages/storeMngStatistics.vue